
export const testColors = {
  testRed : '#ED3237',
  testYellow : '#FFF212',
  testGreen : '#00A859',
  testBlue : '#576AA7',
  testAqua : '#3EA9C9',
  testPurple : '#7D3EC9',
  testPink : '#F2BFCD',
  testLavendar : '#F2BFF1',

}

// ============   NEW COLORS ==================

// -- Blues ----------

export const backgroundBlue = '#3B30CC'
export const bodyBlue ='#1B1625'
export const mutedBackgroundBlue = '#2D259C'
export const shadowBlue = '#040952'
export const chitBlueDull = '#4B6599'
export const chitLightBlueDull = '#A8BEED'
export const veryDarkBlue = '#1E1E34'
export const chitAquaBlue = '#096E99'
export const chitSkyBlue = '#0098DA'
export const chitBlueLight = '#8293B8'
export const chitBlueBrightLight ='#CAE8F6'
export const chitBright = '#97D8EF'
export const chitVeryLightBlue = '#D7EAF7'

// -- Reds  ----------

export const chitPink = '#F7ADAF'
export const chitDarkPink = '#F285B5'
export const chitLightPink = '#F2B5D0'
export const chitBurgandy ='#B02E29'
export const chitBurgandyDull ='#EC7D7A'

// -- Purples ----------

export const chitLavendarLight = '#F266B5'
export const chitLavendar = '#B7B0ED'
export const chitLightLavendar ='#D6D3ED'
export const chitDarkLavendar = '#A49AED'

// -- Greens ----------

export const chitGreen ='#33CC99'
export const chitLightGreen = '#96FFDC'
export const chitVeryLightGreen = '#E4FFEF'
export const chitDarkGreen = '#008000'
export const chitMediumGreen ='#2BAD82'
export const graphGreen = '#00C49F'

// -- Yellows  ----------

export const chitYellow = '#FFF688'
export const chitYellowMedium = '#FFFF94'
export const chitDullYellow = '#F5F08D'
export const chitDullLightYellow ='#F5F0C6'
export const chitGold = '#E4DE0E'


// -- Oranges ----------
export const chitOrange = '#F58634'
export const chitOrangeMedium = '#F8C6A0'
export const chitOrangeLight = '#FADAC1'
export const chitOrangeVeryLight = '#FEEDE2'

// -- Greys ----------

export const highlightGrey = '#606062'
export const darkGrey = '#4B4B4D'
export const headerGrey = '#4B4B4D'
export const mediumGrey = '#727376'
export const mediumMediumGrey = '#A7A7A8'
export const mediumLightGrey = '#CFD0D1'
export const lightGrey = '#E6E7E8'
export const veryLightGrey = '#F6F7F8'


// XXXX  -- OLD CHIT GIT COLORS --   XXXXXXXXXXXXXXXXXXXXX

// export const chitLightYellow =  '#FEFEA1'
// export const chitVeryLightYellow = '#FFFEF7'
// export const chitBrighttYellow = '#FFF688'

export const chitRedDark ='#781F1C'
// export const chitRed = '#FF5451'
// export const chitRedLight = '#FFC3C2'

// export const chitBlueDull = '#4B6599'

// export const chitBlueVeryLight = '#A3B8E6'
// export const chitBlueVeryVeryLight =  '#CDDAFA'
// // export const chitGreen = '#006633'

// export const chitPurple = '#A8518A'




